export function rentalDetail() {
    $('.entry-detail-slider').slick({
        speed: 500,
        slidesToShow: 1,
        dots: false,
        arrows: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 667,
                settings: {
                    dots: true,
                },
            },
        ]
    });

    $('.entry-detail-slider-thumbnails a').click(function () {
        var target = parseInt($(this).data('target'));
        $('.entry-detail-slider-thumbnails a').removeClass('active');
        $(this).addClass('active');
        $('.entry-detail-slider').slick('slickGoTo', target - 1);
    });

    var slider = $('.entry-detail-slider');

    function changeActiveThumbnail(currentSlide) {
        var thumbs = $('.entry-detail-slider-thumbnails a');
        thumbs.removeClass('active');
        thumbs.eq(currentSlide).addClass('active');
    }

    $('.slick-prev').on('click', function () {
        var currentSlide = slider.slick('slickCurrentSlide');
        changeActiveThumbnail(currentSlide);
    });

    $('.slick-next').on('click', function () {
        var currentSlide = slider.slick('slickCurrentSlide');
        changeActiveThumbnail(currentSlide);
        var totalSlides = slider.data('image-length');
        if (currentSlide + 1 === totalSlides) {
            $('.entry-detail-slider').slick('slickGoTo', 0);
        }
    });

    var bikeBoxLength = $('.bikes-slider .slide').length;
    if (bikeBoxLength > 6) {
        $('.bikes-slider').slick({
            speed: 500,
            slidesToShow: 6,
            slidesToScroll: 6,
            dots: false,
            arrows: false,
            infinite: false,
            responsive: [
                {
                    breakpoint: 667,
                    settings: "unslick"
                },
            ]
        });
    } else {
        $('.bikes-slider-wrapper').addClass('static');
    }

    $('.bikes-slider-wrapper .arrow.left').click(function () {
        $('.bikes-slider').slick('slickPrev')
    });
    $('.bikes-slider-wrapper .arrow.right').click(function () {
        $('.bikes-slider').slick('slickNext')
    });

    $('.location-box .infos-holder h4').click(function () {
        $(this).parent().toggleClass('active');
    });

    if ($(window).width() < 667) {
        $('.single-info-holder h2').click(function () {
            $(this).parent().toggleClass('active');
        });
        if (bikeBoxLength > 3) {
            $('.prices-wrapper').addClass('activate-shadow');
        }
    }

    $(function () {
        $('.entry-detail-slider').addClass('loaded');

        $('[data-fancybox="gallery"]').fancybox({
            thumbs: {
                autoStart: true, // Display thumbnails on opening
                hideOnClose: true, // Hide thumbnail grid when closing animation starts
                parentEl: ".fancybox-container", // Container is injected into this element
                axis: "y" // Vertical (y) or horizontal (x) scrolling
            },
        });
        /*const gallery = $('[data-fancybox="gallery"]');
        if (gallery.length) {
            window.initGalleryFancybox = function() {
                console.log('init gallery fancybox');
                gallery.fancybox({
                    thumbs: {
                        autoStart: true, // Display thumbnails on opening
                        hideOnClose: true, // Hide thumbnail grid when closing animation starts
                        parentEl: ".fancybox-container", // Container is injected into this element
                        axis: "y" // Vertical (y) or horizontal (x) scrolling
                    },
                });
            };

            (window.waitForFancyboxJS = function() {
                if (!$.fn.fancybox) {
                    setTimeout(window.waitForFancyboxJS, 50);
                    return;
                }
                initGalleryFancybox();
            })();
        }*/

        //

        var priceList = $('.bike-box.active').find('.prices-list');
        $('.prices-list-wrapper').html(priceList);

        window.trackingRentNowClicked = function() {
            FH.autoLightframe({
                callback: function (linkElement) {
                    gtag('event', 'Rent Now Clicked', {
                        'event_category': 'Rental Detail',
                        'event_label': linkElement.dataset.price,
                        'value': linkElement.dataset.price
                    });
                    $.fancybox.close();
                }
            });
        };

        (window.waitForFH = function() {
            if (!window.FH) {
                setTimeout(window.waitForFH, 50);
                return;
            }
            trackingRentNowClicked();
        })();
    });

    var sidebar = $('.sidebar-wrapper');
    var bookingBox = sidebar.length > 0 ? sidebar.offset().top - 20 : 0;

    $(window).scroll(function () {
        var windowTop = $(window).scrollTop();

        if (windowTop > 250 && !$('.footer').isInViewport()) {
            $('.bottom-rental-bar').addClass('active');
        }
        else {
            $('.bottom-rental-bar').removeClass('active');
        }

        if (sidebar.length > 0 && bookingBox < windowTop && !$('.footer').isInViewport()) {
            sidebar.addClass('sticked');
        }
        else {
            sidebar.removeClass('sticked');
        }
    });

    $('.locations-slider').slick({
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    $('.locations-wrapper .prev').click(function () {
        $('.locations-slider').slick('slickPrev');
    });
    $('.locations-wrapper .next').click(function () {
        $('.locations-slider').slick('slickNext');
    });
}



// WEBPACK FOOTER //
// ./c:/Projects/UB/unlimitedbiking.com/wp-content/themes/unlimitedbiking/slice/assets/js/modules/rentalDetail.js